module.exports = __webpack_public_path__ + "img/平均有效作业工时@3x.8d812916.png";